import { render, staticRenderFns } from "./RegisterAsChildPage.vue?vue&type=template&id=3a38f4fb&scoped=true"
import script from "./RegisterAsChildPage.vue?vue&type=script&lang=js"
export * from "./RegisterAsChildPage.vue?vue&type=script&lang=js"
import style0 from "./RegisterAsChildPage.vue?vue&type=style&index=0&id=3a38f4fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a38f4fb",
  null
  
)

export default component.exports